import React, { useRef, useEffect } from 'react';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import Navbar from './navbar';
import Login from "./login";
import {
    Accordion, Alert,
    Card,
    Col,
    Container,
    ListGroup,
    Nav,
    Row,
    Tabs as BootstrapTabs, Tab as BootstrapTab

} from "react-bootstrap";
import { getAuthHeader } from "./Util";
import { useState } from "react";
import { Prev } from 'react-bootstrap/esm/PageItem';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import DiagramUpload from './DaigramUpload';
import { get, set } from 'lodash';
import loader from '../page_preload.gif';
import { Modal } from "react-bootstrap";
import Badge from 'react-bootstrap/Badge';
import Hotspot from './Hotspot';
import {Carousel} from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./design.css";
import * as XLSX from "xlsx";
import NotificationSystem from 'react-notification-system';


function ImageUpload() {


    const [Msg, setMsg] = useState([]);
    const [FileValidMsg, setFileValidMsg] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const inputFileRef = useRef();
    const notificationSystem = useRef();
    const [disableDownload, setDisableDownload] = useState(false);
    const [data, setData] = useState([]);
    const [errdata, seterrData] = useState([]);
    const [Loading, setLoading] = useState(false);
    const [showHide, setShowHide] = useState(false);
    const [showUploadStatus, setshowUploadStatus] = useState(false);
    const [imagePath, setImagePath] = useState('');
    const [validPartNum, setvalidPartNum] = useState(false);
    const [imageIndex,setImageIndex] = useState(0);
    const [showConflictModal, setShowConflictModal] = useState(false);
    const [conflicts, setConflicts] = useState([]);
    const [conflictChoices, setConflictChoices] = useState({});
    const [invalidFiles, setInvalidFiles] = useState([]);
    const [uploadErrorMsg, setUploadErrorMsg] = useState('');
    const [activeModalTab, setActiveModalTab] = useState('warnings');
    const [apiErrors, setApiErrors] = useState([]);
    const [activeTabIndex, setActiveTabIndex] = useState(0);

    // Cleanup function to reset table-related state
    const clearTableData = () => {
        setData([]);
        setMsg([]);
        setvalidPartNum(false);
        setImageIndex(0);
    };

    // Cleanup function to reset upload-related state
    const clearUploadData = () => {
        setSelectedFiles([]);
        setFileValidMsg([]);
        seterrData([]);
        setUploadErrorMsg('');
        setConflicts([]);
        setConflictChoices({});
        setInvalidFiles([]);
        setApiErrors([]);
        setShowConflictModal(false);
        if (inputFileRef.current) {
            inputFileRef.current.value = '';
        }
    };

    // Cleanup on component unmount
    useEffect(() => {
        return () => {
            clearTableData();
            clearUploadData();
            setShowHide(false);
            setshowUploadStatus(false);
            setLoading(false);
        };
    }, []);

    // Clear data when switching away from Image Upload tab
    useEffect(() => {
        if (activeTabIndex !== 0) {
            // Switching away from Image Upload tab
            clearTableData();
            clearUploadData();
            setShowHide(false);
            setshowUploadStatus(false);
        }
    }, [activeTabIndex]);

    // Handle tab selection - prevent switching tabs while loading
    const handleTabSelect = (index) => {
        if (!Loading) {
            setActiveTabIndex(index);
        }
    };

    const handleFileChange = (event) => {
        setUploadErrorMsg('');
        const fileList = event.target.files;
        const fileNamePattern = /^[a-zA-Z0-9._-]+$/;
        //Perform Validation on Files for filename, length and file type
        const partNum = document.getElementById("partNum").value;
        setFileValidMsg([]);
        //setMsg([]);
        //setSelectedFiles(fileList);
        let clientErrors = [];
        for (let i = 0; i < fileList.length; i++) {
            const file = fileList[i];
            const fileName = file.name;
            const fileType = file.type;

            // Perform validation for filename length
            if (fileName.length > 255) {
                clientErrors.push(fileName + " :Filename length should not exceed 255 characters.");
                //setFileValidMsg(prevItems => [...prevItems, fileName + " :Filename length should not exceed 255 characters."]);
                event.preventDefault();
            }

            // Perform validation for file type
            if (!fileType.includes("image/jpeg")) {
                clientErrors.push(fileName + ":Only jpg file type is allowed.");
                //setFileValidMsg(prevItems => [...prevItems, fileName + ":Only jpg file type is allowed."]);
                event.preventDefault();
            }
            if (file.size > 10000000) {
                clientErrors.push(fileName + " :File size should not exceed 10MB.");
                //setFileValidMsg(prevItems => [...prevItems, fileName + " :File size should not exceed 10MB."]);
                event.preventDefault();
            }

            if (!fileNamePattern.test(fileName)) {
                clientErrors.push(fileName + " :File name contains invalid characters or Spaces.");
                //setFileValidMsg(prevItems => [...prevItems, fileName + " :File name contains invalid characters or Spaces."]);
                event.preventDefault();
            }

            // Continue with other file processing logic
        }
        clientErrors = [...new Set(clientErrors)];
        if (clientErrors.length > 0) {
            setFileValidMsg(clientErrors);
            return;
        } else {
            if (fileList.length > 0) {
                setFileValidMsg([]);
                const nonConflicting = [];
                const conflictsLocal = [];
                const invalidLocal = [];

                setLoading(true);
                const url = `${process.env.REACT_APP_API}/Proxy/DiagramUpload?input=/Files/files/PreValidationForUpload`;
                const formData = new FormData();
                for (let i = 0; i < fileList.length; i++) {
                    formData.append('files', fileList[i]);
                }
                axios.post(url, formData, {
                    headers: {
                        ...getAuthHeader(),
                        'Content-Type': 'application/json'
                    }
                })
                    .then((res) => {
                        Array.from(fileList).forEach(file => {
                            const r = res.data?.filelist?.find(item => item.name === file.name);
                            if (r.status === "") {
                                invalidLocal.push(file.name);
                            } else if (r.status) {
                                // conflict: server returned existing metadata
                                conflictsLocal.push({
                                    name: file.name,
                                    existing: {
                                        name: r.name || file.name,
                                        size: r.size || null,
                                        lastModified: r.lastModifiedDate || null
                                    },
                                    new: file,
                                    newurl: URL.createObjectURL(file)
                                });
                            } else {
                                // server returned valid and no existing -> non-conflicting
                                nonConflicting.push(file);
                            }
                        });
                        setSelectedFiles(nonConflicting);
                        setInvalidFiles(invalidLocal);
                        if (invalidLocal.length > 0) {
                            setSelectedFiles([]);
                            if (inputFileRef.current) {
                                inputFileRef.current.value = '';
                            }
                        }
                        if (conflictsLocal.length > 0) {
                            // initialize conflictChoices default to 'new'
                            const choices = {};
                            conflictsLocal.forEach(c => choices[c.name] = 'new');
                            setConflictChoices(choices);
                            setConflicts(conflictsLocal);
                            setActiveModalTab('conflicts');
                            setShowConflictModal(true);
                        } else if (invalidLocal.length > 0) {
                            // no conflicts, but there are invalid files
                            setConflicts([]);
                            setActiveModalTab('warnings');
                            setShowConflictModal(true);
                        } else {
                            // no conflicts and no invalid files
                            setConflicts([]);
                            setShowConflictModal(false);
                        }
                        setLoading(false);
                    })
                    .catch((error) => {
                        setLoading(false);
                        let errorMsg = '';
                        if (typeof error.response?.data === 'string') {
                            setApiErrors(['Error Occured while validating data.']);
                            setSelectedFiles([]);
                            setConflicts([]);
                            setActiveModalTab('error');
                            setShowConflictModal(true);
                        } else if (error.response?.data?.filelist) {
                            error.response.data.filelist.forEach(file => {
                                invalidLocal.push(file);
                            });
                            setInvalidFiles(invalidLocal);
                            if (invalidLocal.length > 0) {
                                setSelectedFiles([]);
                                setConflicts([]);
                                setActiveModalTab('warnings');
                                setShowConflictModal(true);
                            } else {
                                setShowConflictModal(false);
                            }
                        } else {
                            setApiErrors(['Unexpected error occured while validating data.']);
                            setActiveModalTab('error');
                            setShowConflictModal(true);
                        }
                    });
            }
            else {
                setShowConflictModal(false);
                setConflicts([]);
                setConflictChoices({});
                setLoading(false);
            }

        }
    }

    const handleDownloadExcel = async () => {

        setDisableDownload(true);

        const notification = notificationSystem.current;

        notification.addNotification({
            title: 'Download Message',
            level: 'info',
            position: 'tc',
            children: (
                <div className="search btn btn-primary">
                    <b>  <h5 >Download in progress for part numbers containing photos.</h5></b>
                </div>
            ),
        });

        // Example test data
        await axios.get(`${process.env.REACT_APP_API}/proxy/get?input=/Files/files/GetPartNumbers`,
            {
                headers: {
                    ...getAuthHeader(),
                    timeout: 0 // Set timeout to 60 seconds for this request
                }
            }).then((res) => {
                setDisableDownload(false);

                if (!Array.isArray(res.data) || res.data.length === 0) {
                    throw new Error("No data received");
                }

                if (res?.data?.length > 0) {
                    // Convert JSON to worksheet
                    const worksheet = XLSX.utils.json_to_sheet(res?.data);

                    // Create workbook & add worksheet
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "PartNumber");

                    // Generate Excel file and trigger download
                    XLSX.writeFile(workbook, "PartNo_with_photo.xlsx");
                    

                    notification.addNotification({
                        title: 'Download Message',
                        level: 'info',
                        position: 'tc',
                        children: (
                            <div className="search btn btn-primary">
                                <b>  <h5 >Excel file downloaded successfully.</h5></b>
                            </div>
                        ),
                    });
                }
            }).catch((error) => {
                setFileValidMsg('Error occurred while downloading. Please try again.');
                setDisableDownload(false);
            });
    };


    const HandleSubmit = (event) => {
        if (inputFileRef.current.value == '') {
            setFileValidMsg([]);
            setFileValidMsg(prevItems => [...prevItems, "Please select file to Upload!!"]);
            event.preventDefault();
        }
        else {
            // Clear previous errors and status
            setFileValidMsg([]);
            seterrData([]);
            setUploadErrorMsg('');
            setshowUploadStatus(false);

            if (FileValidMsg.length == '0') {
                // setMsg([]);
                setFileValidMsg([]);
                // var confirmed, text = '';
                // for (let i = 0; i < selectedFiles.length; i++) {
                //     data.map(element => {
                //         if (selectedFiles[i].name == element) {
                //             text += element + '\n ';
                //         }
                //     });
                // }


                // if (text != '') {
                //     confirmed = window.confirm("Following File/s already Exists:-\n" + text + "It will replace the existing files.Do you want to Continue?");

                // }
                // else {
                //     confirmed = true;
                // }
                if (true) {
                    const url = `${process.env.REACT_APP_API}/Proxy/DiagramUpload?input=/Files/files/Upload`
                    const formData = new FormData();
                    for (let i = 0; i < selectedFiles.length; i++) {
                        formData.append('files', selectedFiles[i]);
                    }
                    setLoading(true);
                    axios.post(url, formData, {
                        headers: {
                            ...getAuthHeader(),
                            'Content-Type': 'multipart/form-data'
                        },

                    })
                        .then((res) => {
                            setshowUploadStatus(true);
                            if (res.data) { seterrData(res.data) }

                            setLoading(false);
                            inputFileRef.current.value = '';
                            // Clear selected files and upload-related state after successful upload
                           // setSelectedFiles([]);
                           // setConflicts([]);
                           // setConflictChoices({});
                          //  setInvalidFiles([]);
                           // setShowConflictModal(false);
                        })
                        .catch((error) => {
                            if (error.response) {
                                setFileValidMsg(prevItems => [...prevItems, "Error Occured while uploading image, Please try again"]);
                            }
                            
                            setLoading(false);
                        });
                }
            }
        }
    }


    const handleBlur = (event) => {
        if (event.target.value == "") {
            clearTableData();
            setShowHide(false);
        }
        else {
            setMsg([]);
            let urlprod;
            setLoading(true);
            urlprod = `${process.env.REACT_APP_API}/proxy/get?input=/Files/files/Checkpartnumberexist/` + event.target.value.toUpperCase();
            axios.get(urlprod, {
                headers: {
                    ...getAuthHeader()
                }
            })
                .then((res) => {
                    if (res.data) {
                        setData(res.data);
                        setvalidPartNum(true);
                        setLoading(false);
                    }

                }, (error) => {
                    setLoading(false);
                    setvalidPartNum(false);
                    if (error.response != null) {
                        setMsg(prevItems => [...prevItems, "Incorrect Part Number!"]);
                    }
                    else {
                        setMsg(prevItems => [...prevItems, "Error Occured while fetching data."]);
                    }
                });
        }
    }

    function getData(partNum) {
        let urlprod;
        setLoading(true);
        urlprod = `${process.env.REACT_APP_API}/proxy/get?input=/Files/files/Checkpartnumberexist/` + partNum.toUpperCase();
        axios.get(urlprod, {
            headers: {
                ...getAuthHeader()
            }
        })
            .then((res) => {
                setData(res.data);
                setLoading(false);
            }, (error) => {
                setLoading(false);
                setMsg(prevItems => [...prevItems, "Error Occured while checking part number."]);
            });
    }


    const handleDelete = (image) => {
        const partNum = document.getElementById("partNum").value;
        if (image == partNum + ".jpg") {
            if (data.length > 1) {
                alert("Part Number cannot be deleted as it has images uploaded!! Please delete the additional images first.");
                return;
            }
        }
        const confirmed = window.confirm("Are you sure you want to delete this item?");
        if (confirmed) {
            let urlprod;
            setLoading(true);
            setMsg([]);
            urlprod = `${process.env.REACT_APP_API}/Proxy/get?input=/Files/files/DeleteImage/` + image + '/' + partNum;
            axios.get(urlprod, {
                headers: {
                    ...getAuthHeader()
                }
            })
                .then((res) => {

                    setMsg(prevItems => [...prevItems, res.data]);
                    setLoading(false);
                    getData(partNum);
                }, (error) => {
                    setLoading(false);
                    setMsg(prevItems => [...prevItems, " Error Occured while deleting the file."]);
                })
        }
    }

    const showImage = (file,index) => {
        setImagePath(`${process.env.REACT_APP_IMAGE_PATH}` + '/' + file);
        setImageIndex(index);
        setShowHide(true);
    }

    // const closeModal = () => {
    //     setShowHide(false);
    //     setshowUploadStatus(false);
    //     // Clear upload-related data when closing upload status modal
    //     if (showUploadStatus) {
    //         clearUploadData();
    //     }
    // };

    const closeModal = () => {
        setShowHide(false);
        setshowUploadStatus(false);
        clearUploadData();
        getData(document.getElementById("partNum")?.value);
    };

    // conflict modal helpers
    const handleConflictChoiceChange = (filename, value) => {
        setConflictChoices(prev => ({ ...prev, [filename]: value }));
    };

    const confirmConflicts = () => {
    if ((!conflicts || conflicts.length === 0) && FileValidMsg.length > 0) {
        // Only validation errors, no conflicts: clear file input, selectedFiles, and FileValidMsg, close modal
        clearUploadData();
        return;
    }
    setSelectedFiles(prev => {
        const additions = [];
        conflicts.forEach(c => {
            const choice = conflictChoices[c.name] || 'new';
            if (choice === 'new') {
                additions.push(c.new);
            }
            // if choice is 'old': do nothing (we keep existing)
        });
        return [...prev, ...additions];
    });
    // close modal and clear conflicts
    setShowConflictModal(false);
    setConflicts([]);
    setConflictChoices({});
    setApiErrors([]);
};


    const cancelConflicts = () => {
        // user cancelled; keep non-conflicting files only
        setShowConflictModal(false);
        setConflicts([]);
        setConflictChoices({});
        setApiErrors([]);
        // If there are only FileValidMsg errors (no conflicts), clear file input and FileValidMsg so modal closes
        //if (FileValidMsg.length > 0 && (!conflicts || conflicts.length === 0)) {
            clearUploadData();
        //}
    };

    return (
        <>
            < React.Fragment >
            <NotificationSystem ref={notificationSystem} />

                <div>
                    <Navbar />
                    <div style={{ marginRight: "10px" }}>
                        <br />
                        <Login />
                        <br />
                    </div>
                </div>



                <Container>
                    <h1>PartSurfer Image & Diagram Upload Utility</h1>
                    <Tabs selectedIndex={activeTabIndex} onSelect={handleTabSelect}>
                        <TabList>
                            <Tab>Image Upload</Tab>
                            <Tab>Diagram Upload</Tab>
                            <Tab>Hotspot</Tab>
                        </TabList>

                        <TabPanel>
                            <form>
                                <div style={{ position: 'relative', boxSizing: 'border-box' }}>
                                    {Loading && <div>
                                        <div style={{
                                            position: 'fixed',
                                            height: '100%',

                                            zIndex: 999,
                                            display: 'block', width: '100%', textAlign: 'center'
                                            , top: '40%'
                                        }}>
                                            <img src={loader} alt="loading..." />
                                            <br />
                                            Please wait for the moment....
                                        </div>
                                    </div>}
                                    {Loading ? <div style={{ opacity: '0.5' }}>

                                    </div> : null}
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-md-4">
                                        <label> <b>Enter Part Number to View Uploaded Images: </b></label>
                                        <input type="text" class="form-control" id="partNum" onBlur={handleBlur} placeholder="Enter Part Number" style={{ textTransform: 'uppercase' }} />
                                        <ul>
                                            {Msg.map(item => (
                                                <li style={{ color: 'red' }}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label> <b>Select Files to Upload: </b></label>
                                        <div className="d-flex align-items-center mb-3">
                                            <input  className="form-control" type="file" accept="image/jpeg" id="formFile" multiple onChange={handleFileChange} ref={inputFileRef} style={{ maxWidth: '316px' }} />

                                            {/* Upload Button */}
                                            <button type="button" className="btn btn-primary" onClick={HandleSubmit}>Upload</button>

                                            <div style={{ marginLeft: '10px', whiteSpace: 'nowrap' }}>
                                                <button
                                                    onClick={handleDownloadExcel}
                                                    disabled={disableDownload}
                                                    style={{
                                                        color: "#0096D6",
                                                        background: "none",
                                                        border: "none",
                                                        padding: 0,
                                                        cursor: disableDownload ? "not-allowed" : "pointer",
                                                        opacity: disableDownload ? 0.6 : 1,
                                                    }}
                                                >
                                                    <b>Download Part Numbers</b>
                                                </button>
                                            </div>
                                        </div>
                                    </div>


                                    {/* {validPartNum && (
                                        <> */}

                                    <div class="form-group col-md-4">
                                        {uploadErrorMsg && (
                                            <div style={{ color: 'red', marginTop: '5px' }}>{uploadErrorMsg}</div>
                                        )}
                                        {/* {FileValidMsg.length > 0 && (
                                            <div class="form-row" style={{ height: '100px', border: '1px solid black', overflow: 'auto' }}>

                                                <div>
                                                    <center>  <strong style={{ color: 'red' }}>Error Messages:-</strong></center>
                                                </div>
                                                <br />
                                                <ul>
                                                    {FileValidMsg.map(item => (
                                                        <li style={{ color: 'red' }}>{item}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )} */}
                                        {/* <b>GuideLines:-</b><br />
                                        <ul><h6><li>You can Upload multiple Images.</li></h6>
                                            <h6> <li>Allowed Image types are jpg.</li></h6>
                                            <h6>  <li>Name of the file must be Part Number.</li></h6>
                                            <h6>  <li>Maximum Image size allowed to upload is 10MB.</li></h6>
                                        </ul> */}

                                    </div>
                                    {/* </>
                                    )} */}
                                </div>

                                {/* <div class="form-row">
                                    <div class="form-group col-md-8"> */}

                                <p style={{ fontSize: 'smaller' }}> <b>GuideLines:-</b> You can Upload multiple Images.
                                    Allowed Image types are jpg.
                                    Name of the file must be Part Number.
                                    Maximum Image size allowed to upload is 10MB.</p>

                                {/* </div>
                                </div> */}
                                {/* <div class="form-row" style={{ height: '100px', border: '1px solid black', overflow: 'auto' }}>
                                    <ul>
                                        {FileValidMsg.map(item => (
                                            <li style={{ color: 'red' }}>{item}</li>
                                        ))}
                                    </ul>
                                </div> */}

                            </form>

                            {validPartNum && (
                                <>
                                    <div>

                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Sr No</th>
                                                    <th>Image Name</th>
                                                    <th>Delete</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {!data.length > 0 && (
                                                    <tr>
                                                        <td colSpan={4}><center>No Data Found</center></td>
                                                    </tr>
                                                )}
                                                {data.map((item, index) => (
                                                    <tr>
                                                        <td>{index + 1}</td>
                                                        <td style={{ cursor: "pointer" }} title="Click to view Image" onClick={() => showImage(item, index)}><u>{item}</u></td>
                                                        <td>
                                                            <button onClick={() => handleDelete(item)}>Delete</button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                </>
                            )}

                        </TabPanel >
                        <TabPanel>
                            <DiagramUpload />
                        </TabPanel >
                        <TabPanel>
                            <Hotspot />
                        </TabPanel >
                    </Tabs>
                </Container>
                <br />
                <br />


            </React.Fragment >
            <React.Fragment>

                <Modal size="lg" scrollable show={showUploadStatus} onHide={closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Image Upload Status </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <center>

                            <button className='btn btn-primary mr-2'>
                                Uploaded Files  <span class="badge badge-light">{selectedFiles.length}</span>
                            </button>
                            <button className='btn btn-success mr-2'>
                                Success  <span class="badge badge-light">{selectedFiles.length - errdata.length}</span>
                            </button>
                            <button className='btn btn-danger mr-2'>
                                Failed <span class="badge badge-light">{errdata.length}</span>
                            </button>


                        </center>
                        <br />

                        <div>

                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Sr No</th>
                                        <th>Image Name</th>
                                        <th>Reason</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!errdata.length > 0 && (
                                        <tr>
                                            <td colSpan={3}><center>All Good.No issues Found.</center></td>
                                        </tr>
                                    )}
                                    {errdata.map((item, index) => (
                                        <tr>
                                            <td>{index + 1}</td>
                                            <td>{item + ".jpg"}</td>
                                            <td>
                                                Not found in the database.
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>



                    </Modal.Body>
                    <Modal.Footer>

                    </Modal.Footer>
                </Modal>

            </React.Fragment >


<Modal size="lg" scrollable show={showConflictModal || FileValidMsg.length > 0} onHide={cancelConflicts}>
    <Modal.Header closeButton>
        <Modal.Title>Pre-Upload Checks</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <BootstrapTabs activeKey={activeModalTab} onSelect={(k) => setActiveModalTab(k)} id="conflict-tabs">
            <BootstrapTab eventKey="conflicts" title="Conflicting Files">
                <p style={{ fontSize: '0.9rem', marginBottom: '1rem' }}>Choose per-file whether to keep the server (Old) or replace with your local file (New).</p>
                <div style={{
                    maxHeight: "350px",
                    overflowY: "auto",
                    border: "1px solid #ddd"
                }}>
                    <table className="table table-striped" style={{ margin: 0 }}>
                        <thead style={{ position: "sticky", top: 0, background: "white", zIndex: 5 }}>
                            <tr>
                                <th>Old file</th>
                                <th>New file</th>
                                <th>Keep</th>
                            </tr>
                        </thead>
                                    <tbody>
                                        {conflicts.length === 0 ? (
                                            <tr>
                                                <td colSpan={3}><center>No conflicts found.</center></td>
                                            </tr>
                                        ) : (conflicts.map((c, idx) => (
                                            <tr key={c.name}>
                                                <td>
                                                    {c.existing ? (
                                                        <div style={{
                                                            display: "flex",
                                                            alignItems: "stretch",
                                                            gap: "10px",
                                                        }}>
                                                            <img src={`${process.env.REACT_APP_IMAGE_PATH}/${c.existing.name}`}
                                                                alt="old file" style={{
                                                                    width: 40,
                                                                    objectFit: "cover",
                                                                    borderRadius: 4,
                                                                }}
                                                            />
                                                            <div style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                justifyContent: "center",
                                                                fontSize: "12px",
                                                            }}>
                                                                <div>Name: {c.existing.name}</div>
                                                                <div>Size: {(c.existing.size / 1024).toFixed(1) || "N/A"} KB</div>
                                                                <div>
                                                                    LastModified:{" "}
                                                                    {c.existing.lastModified
                                                                        ? new Date(c.existing.lastModified).toLocaleDateString()
                                                                        : "N/A"}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div>Not Found</div>
                                                    )}
                                                </td>
                                                <td>
                                                    <div style={{
                                                        display: "flex",
                                                        alignItems: "stretch",
                                                        gap: "10px",
                                                    }}>
                                                        <img
                                                            src={c.newurl}
                                                            alt="new file"
                                                            style={{
                                                                width: 40,
                                                                objectFit: "cover",
                                                                borderRadius: 4
                                                            }}
                                                        />
                                                        <div style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            justifyContent: "center",
                                                            fontSize: "12px",
                                                        }}>
                                                            <div>Name: {c.new.name}</div>
                                                            <div>Size: {(c.new.size / 1024).toFixed(1)} KB</div>
                                                            <div>Last Modified: {c.new.lastModified ? new Date(c.new.lastModified).toLocaleDateString() : "N/A"}</div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        <label style={{ marginRight: '8px' }}>
                                                            <input type="radio" name={`choice_${idx}`} checked={conflictChoices[c.name] === 'old'} onChange={() => handleConflictChoiceChange(c.name, 'old')} /> Old
                                                        </label>
                                                        <label>
                                                            <input type="radio" name={`choice_${idx}`} checked={conflictChoices[c.name] === 'new'} onChange={() => handleConflictChoiceChange(c.name, 'new')} /> New
                                                        </label>
                                                    </div>
                                                </td>
                                            </tr>
                                        )))}
                                    </tbody>
                    </table>
                </div>
            </BootstrapTab>
            <BootstrapTab eventKey="warnings" title="Warning Messages">
                {FileValidMsg.length > 0 ? (
                    <ul style={{ maxHeight: '400px', overflowY: 'auto', marginTop: '8px' }}>
                        {FileValidMsg.map((msg, idx) => (
                            <li key={idx} style={{ color: 'red', marginBottom: '8px' }}>{msg}</li>
                        ))}
                    </ul>
                ) : 
                invalidFiles.length > 0 ? (
                                            <div style={{ maxHeight: '400px', border: '1px solid grey', overflow: 'auto', marginTop: '8px', padding: '8px' }}>
                                                <div style={{ marginBottom: '12px', marginLeft: '8px' }}>
                                                    <strong style={{ color: 'red' }}>Invalid Partnumbers</strong>
                                                </div>
                                                <ul style={{ marginBottom: 0 }}>
                                                    {invalidFiles.map(n => <li key={n} style={{ color: 'red', marginBottom: '6px' }}>{n}</li>)}
                                                </ul>
                                            </div>
                                        )
                                        :(
                    <div>No warnings found.</div>
                )}

            </BootstrapTab>
            <BootstrapTab eventKey="error" title="Error Messages">
                {apiErrors.length > 0 ? (
                    <ul style={{ maxHeight: '400px', overflowY: 'auto', marginTop: '8px' }}>
                        {apiErrors.map((msg, idx) => (
                            <li key={idx} style={{ color: 'darkred', marginBottom: '8px' }}>{msg}</li>
                        ))}
                    </ul>
                ) : (
                    <div>No errors found.</div>
                )}
            </BootstrapTab>
        </BootstrapTabs>
    </Modal.Body>
    <Modal.Footer>
        <button className="btn btn-primary" onClick={cancelConflicts}>Cancel</button>
        <button className="btn btn-primary" onClick={confirmConflicts}>OK</button>
    </Modal.Footer>
</Modal>

            <React.Fragment>

                <Modal size="lg" scrollable show={showHide} onHide={closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>View Image</Modal.Title>
                    </Modal.Header>
                    <Modal.Body id="PopupId">

                        <img id="diaImg" className="responsive" src={imagePath} alt="Image Cannot Be Displayed" ></img>
                    </Modal.Body>
                    <Modal.Footer>

                    </Modal.Footer>
                </Modal>

            </React.Fragment>

            <React.Fragment>

                <Modal size="lg" scrollable show={showHide} onHide={closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>View Image</Modal.Title>
                    </Modal.Header>
                    <Modal.Body id="PopupId">
                      <Carousel
                      selectedItem={imageIndex}
                      showThumbs={false}
                      infiniteLoop
                      useKeyboardArrows
                      showArrows
                      showIndicators
                      showStatus={false}
                      >
                        {data.map((img, ind)=>(
                            <div key={ind}>
                        <img id="diaImg" className="responsive" src={`${process.env.REACT_APP_IMAGE_PATH}` + '/' + img} alt="Image Cannot Be Displayed" ></img>
                            </div>
                        ))}

                      </Carousel>
                    </Modal.Body>
                    <Modal.Footer>

                    </Modal.Footer>
                </Modal>

            </React.Fragment>
        </>


    )
}
export default ImageUpload;
